import { network } from '@utils'
import { handleReturn, MutationFunction, PaginatedResponse, QueryFunction } from './root'

export interface IUsershipPermission {
  name: string
  value: boolean
  explanation: string
}

export interface INocfoPermissions {
  admin: IUsershipPermission
  bookkeeping_read: IUsershipPermission
  bookkeeping_editor: IUsershipPermission
  bookkeeping_attachment: IUsershipPermission
  bookkeeping_admin: IUsershipPermission
  bookkeeping_lock_documents: IUsershipPermission
  accounts_read: IUsershipPermission
  accounts_editor: IUsershipPermission
  files_read: IUsershipPermission
  files_editor: IUsershipPermission
  invoicing_read: IUsershipPermission
  invoicing_editor: IUsershipPermission
  invoicing_admin: IUsershipPermission
  contact_read: IUsershipPermission
  contact_editor: IUsershipPermission
  reporting_read: IUsershipPermission
  reporting_editor: IUsershipPermission
  reporting_admin: IUsershipPermission
  salary: IUsershipPermission
  integration_admin: IUsershipPermission
  expense_claims_read: IUsershipPermission
  expense_claims_editor: IUsershipPermission
}

export interface IUsershipPerson {
  id: number
  user_id: number
  first_name: string
  last_name: string
  email: string
  avatar_url: string
  permissions: INocfoPermissions
  managed_holvi_accounts: number[]
  tags: string[]
}

interface PersonListProps {
  slug: string
}

export const fetchPeople: QueryFunction<
  PersonListProps,
  PaginatedResponse<IUsershipPerson>
> = async ({ slug }, params = null) => {
  const url = `/v1/business/${slug}/people/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET',
    params
  })
  return data
}

interface PersonInstanceProps extends PersonListProps {
  usershipId: number
}

export const deleteUsership: MutationFunction<PersonInstanceProps, void> = async ({
  slug,
  usershipId
}) => {
  const url = `/v1/business/${slug}/people/${usershipId}/`
  const { status, data } = await network.httpClient.request({
    url,
    method: 'DELETE',
    validateStatus: () => true
  })

  return handleReturn({ status, data })
}

export const updateUsership: MutationFunction<PersonInstanceProps, IUsershipPerson> = async (
  { slug, usershipId },
  requestData
) => {
  const url = `/v1/business/${slug}/people/${usershipId}/`
  const { status, data } = await network.httpClient.request({
    url,
    method: 'PATCH',
    data: requestData,
    validateStatus: () => true
  })

  return handleReturn({ data, status })
}
